import React from 'react'
import TeamPage from '../../src/Components/Utils/Teams/TeamPage';

function Team() {
    return (
        <div>
            <TeamPage/>
        </div>
    )
}

export default Team
